import React from 'react';
import { Button } from '@mui/material';

const ButtonCheckbox = ({
    value = false,
    onChange,
    trueLabel = 'On',
    falseLabel = 'Off',
    color = 'primary',
    sx = {},
}) => {
    const handleClick = () => {
        onChange?.(!value); // toggle like checkbox
    };

    return (
        <Button
            onClick={handleClick}
            variant={value ? 'contained' : 'outlined'} // filled when true
            color={color}
            sx={{
                textTransform: 'none',
                borderRadius: 2,
                minWidth: 64,
                px: 2,
                ...sx,
            }}
        >
            {value ? trueLabel : falseLabel}
        </Button>
    );
};

export default ButtonCheckbox;
